import { ixlBranding, rsBranding, social } from "@resourcehub/resourcehub-assets";
import footerIxlLogo from "../../../../global/footer.ixl-logo";
import footerRsLogo from "../../../../global/footer.rs-logo";

export default ({ strings }) => ({
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,

        market: "la",
        domain: ".espanol",
        vertical: "consumer",
        page: "home",

        // Strings
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/comprar-ingles/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-frances/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-italiano/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-aleman/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-espanol-espana/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-japones/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_japanese_label
                    },
                    {
                        visible: true,
                        destination: "/comprar-chino/",
                        external: true,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_buy_chinese_label
                    },
                    {
                        visible: true,
                        destination: "/regalo/",
                        external: false,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_gift_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/buynow/",
                        external: false,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_buy_all_label
                    }
                ]
            },
            {
                label: strings.footer_menu_learn_label,
                links: [
                    {
                        visible: true,
                        destination: "/idiomas/aprender-ingles/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_learn_english_label
                    },
                    {
                        visible: true,
                        destination: "/idiomas/curso-de-frances/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_learn_french_label
                    },
                    {
                        visible: true,
                        destination: "/idiomas/aprender-italiano/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_learn_italian_label
                    },
                    {
                        visible: true,
                        destination: "/idiomas/aprender-portugues/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_learn_portuguese_label
                    },
                    {
                        visible: true,
                        destination: "/idiomas/idioma-aleman/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_learn_german_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/pruebaloya/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/movil/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/opiniones-clientes/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/testimonios/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_start_testamonials_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/translate/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_start_translate_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/about/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/locaciones/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_about_retail_partners_label
                    },
                    {
                        visible: true,
                        destination: "/descuento-militar/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_about_military_discount_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/endangered/",
                        external: false,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_about_endangered_languages_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/es/",
                        external: true,
                        new_window: true,

                        // Labels
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/pf/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contacto/",
                        external: false,
                        new_window: false,

                        // Labels
                        label: strings.footer_menu_support_contact_us_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/lp/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://www.therosettastone.com.au/",
                    label: strings.footer_region_options_au_label
                },
                {
                    destination: "https://pt.rosettaston.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});
